import * as Mod1 from "./discourse/connectors/admin-user-details/patreon.gjs";
import * as Mod2 from "./discourse/connectors/topic-above-footer-buttons/patreon.gjs";
import * as Mod3 from "./discourse/initializers/patreon-admin-plugin-configuration-nav";
import * as Mod4 from "./discourse/initializers/patreon";
import * as Mod5 from "./discourse/models/filter-rule";
import * as Mod6 from "./discourse/patreon-route-map";
const compatModules = {
  "discourse/connectors/admin-user-details/patreon": Mod1,
  "discourse/connectors/topic-above-footer-buttons/patreon": Mod2,
  "discourse/initializers/patreon-admin-plugin-configuration-nav": Mod3,
  "discourse/initializers/patreon": Mod4,
  "discourse/models/filter-rule": Mod5,
  "discourse/patreon-route-map": Mod6,
};
export { compatModules };
export default compatModules;
